import { TextHeader as TextHeaderUI } from "@repo/ui-parkmobile/TextHeader";
import type { TextHeader } from "@/generated/sb";
import { sectionHeaderResolver } from "@/lib/storyblok/adaptors";
import { storyblokEditable } from "@storyblok/react/rsc";

interface TextHeaderProps {
  blok: TextHeader;
}

export default function TextHeader({ blok }: TextHeaderProps) {
  if (!blok) {
    return null;
  }

  return (
    <TextHeaderUI
      {...storyblokEditable(blok)}
      content={sectionHeaderResolver(blok.content) || undefined}
      backgroundColor={blok.backgroundColor || "none"}
      topPadding={blok.topPadding || "none"}
      bottomPadding={blok.bottomPadding || "none"}
    />
  );
}
